import Vue from "vue";
import VueRouter from "vue-router";
import App from "../App.vue";

//import page per-fitur
import Example from "@/pages/Example";
import playground from "@/pages/playground";
import auth from "@/pages/auth";
import Dashboard from "@/pages/Dashboard";
import scanMesin from "@/pages/Scan";
import Riwayat from "@/pages/Riwayat";
import akun from "@/pages/akun";
import topup from "@/pages/TopUp";

Vue.use(VueRouter);

const routes = [
  {
    path: "",
    component: App,
    children: [
      ...auth.router,
      ...Example.router,
      ...playground.router,
      ...Dashboard.router,
      ...scanMesin.router,
      ...Riwayat.router,
      ...akun.router,
      ...topup.router,
      {
        path: "*",
      },
    ],
  },
];
const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");
  // console.log("ini isi to " + to.meta.requireAuth);
  // console.log(token);

  if (to.meta.requireAuth == true) {
    if (!token) {
      next({
        name: "index",
      });
      return;
    }
    next();
    return;
  }

  if (to.meta.requireAuth == false) {
    if (token) {
      next({
        name: "dashboardUtama",
      });
    }
    next();
    return;
  }
  // if (to.matched.some((record) => record.meta.requireAuth)) {
  //   if (!token) {
  //     next({
  //       path: "/login",
  //     });
  //   } else {
  //     next();
  //   }
  // } else {
  //   next();
  // }
  // if (to.meta.auth ?? false) {
  //   next();
  //   return;
  // } else {
  //   if (token) {
  //     next();
  //     return;
  //   } else {
  //     next({ name: "Login" });
  //     return;
  //   }
  // }
});
export default router;
